import { IComponentController, IScope } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IParametresSecuriteService } from '../../../../../core/services/parametres-securite.service';
import { IStateParamsService } from 'angular-ui-router';

interface IPageAc0074 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    taxMultiOccurrenceOptions: IMultiOccurrenceOptions;
    taxMultiOccurrence: IMultiOccurrence;
    dnvMultiOccurrenceOptions: IMultiOccurrenceOptions; 
}

/* @ngInject */
export default function Ac0074Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    MenuItemEcran: IMenuItemEcranClass,
    $scope: IScope,
    $stateParams: IStateParamsService,
    parametresSecurite: IParametresSecuriteService,
    ecranDetails: IEcranDetailsResourcesEntite,
    mc0044Route: IRoute) {

    const vm: IPageAc0074 = this;
    vm.valeursEcran = ecranDetails.valeurs; 

    vm.monoOccurrenceOptions = {
        fonctions: {
            afficherMenusDansEntete: true,
            boutonDupliquer: false,
            suiviModification: false,
            exportation: false
        },
        formulaire: new Formulaire('', [
            new FormulaireItem('dacnumdoc'),
            new FormulaireItem('dcnseqave'),
            new FormulaireItem('peccleint'),
            new FormulaireItem('intcleintreq')
        ], { largeurDefaut: 25 })
    };

    vm.dnvMultiOccurrenceOptions = {
        bloc: 'dnv',
        editionRapideActive: true,
        fonctions: {
            editionRapide: true , 
            supprime: (data:any) => ! ( data.dnvflgcon)
        }, 
        colonnesFixesGauche: [
            {
                nom: 'imp', largeur: 300, menu: [
                    new MenuItemEcran(
                        '',
                        mc0044Route.NAME,
                        (rowData: any) => ({
                            id: rowData.prucleint,
                            prucleint: rowData.prucleint
                        }),
                        {
                            icon: 'launch',
                            iconButton: false,
                            secondaire: true,
                            fonction: 'BOUIMPUT',
                            hidden: (data: any) => !data.flgcen
                        })
                ]
            }
            
        ],
        
        colonnesVisibles: [
            { nom: 'dnvmnt', largeur: 130, total: true },
            { nom: 'dnvmnttaxfed', largeur: 130, total: true },
            { nom: 'dnvmnttaxpro', largeur: 130, total: true },
            { nom: 'dnvmntremfed', largeur: 130 },
            { nom: 'dnvmntrempro', largeur: 130 },
            { nom: 'dnvmntdepnet', largeur: 130 },
        ],
        colonnesEditionRapide: [
            { nom: 'imp', largeur: 130 },
            { nom: 'remcleint', largeur: 130 },
            { nom: 'remcod', largeur: 130, hidden: true },
            { nom: 'dnvmnt', largeur: 130 },
            { nom: 'dnvmnttaxfed', largeur: 130 },
            { nom: 'dnvmnttaxpro', largeur: 130 },
            { nom: 'taxcleint', largeur: 130 , hidden:true },
            { nom: 'dnvmntremfed', largeur: 130 },
            { nom: 'dnvmntrempro', largeur: 130 },
            { nom: 'dnvmntdepnet', largeur: 130 },
            { nom: 'dcncleint', largeur: 130 , hidden:true },
            { nom: 'diecleint', largeur: 130 , hidden:true}
        ], 
        formulaire: new Formulaire([
            new FormulaireItem('imp',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('remcleint',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('dnvmnt',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('dnvmnttaxfed',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('dnvmnttaxpro',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dnvmntremfed',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('dnvmntrempro',{
                readonly:(data:any)=>data.dnvflgcon
            }),
            new FormulaireItem('dnvmntdepnet',{
                readonly:(data:any)=>data.dnvflgcon
            }),  
            new FormulaireItem('taxcleint',{
                hidden: true,
            }),
            new FormulaireItem('diecleint',{
                hidden: true,
            }) 
        ], { largeurDefaut: 33 }),
        colonnesCachees: [
            'prucleint',
            'dnvflgcon',
            'flgcen'
        ]
    }; 
    vm.taxMultiOccurrenceOptions = {
        bloc: 'tax', 
        resourceParams:(rowData: any ) => ({
            taxcleint : rowData.prucleint,
            diecleint : rowData.diecleint
        }),
        fonctions: {
            criteresSuggeresVisibles: false,
            criteresRechercheOpened: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('seltax', { 
                default: 'T' ,
                 hidden: vm.valeursEcran.typvnt  === 'DAC' 
            }),
            new FormulaireItem('seltax_lig', {
                 default: 'T',
                 hidden: vm.valeursEcran.typvnt  !== 'DAC' 
         })
        ]),
        colonnesVisibles: [   
            { nom: 'dielig', largeur: 100 ,  hidden: vm.valeursEcran.typvnt  === 'DAC'},
            { nom: 'diedsc', largeur: 100 ,  hidden:(rowData:any)=> ( vm.valeursEcran.typvnt  === 'DAC') },
            { nom: 'dieqte', largeur: 100 ,  hidden:(rowData:any)=> (vm.valeursEcran.typvnt  === 'DAC' ) },
            { nom: 'taxcod', largeur: 100 ,  hidden:(rowData:any)=> (vm.valeursEcran.typvnt  !== 'DAC' )},
            { nom: 'taxdscfed', largeur: 200 ,  hidden:(rowData:any)=> (vm.valeursEcran.typvnt  !== 'DAC' )},
            { nom: 'taxdscpro', largeur: 200 ,  hidden:(rowData:any)=> (vm.valeursEcran.typvnt  !== 'DAC' )},
            { nom: 'dienbr', largeur: 100  ,  hidden:(rowData:any)=> (vm.valeursEcran.typvnt  !== 'DAC' )},
            { nom: 'diemnt', largeur: 130 },
            { nom: 'taxcod_item', largeur: 130 ,  hidden:(rowData:any)=> ( vm.valeursEcran.typvnt  === 'DAC')},
            { nom: 'diemnttaxfed', largeur: 130 },
            { nom: 'diemnttaxpro', largeur: 130 },
            { nom: 'mnteca', largeur: 130 },
            { nom: 'mntecataxfed', largeur: 130 },
            { nom: 'mntecataxpro', largeur: 130 } 
        ],
        colonnesCachees: ['diecleint','taxcleint'],
        multiOccurrenceOptionsEnfant: vm.dnvMultiOccurrenceOptions
    }; 
} 
